export const checkFileImageUpload = (data) => {
    const file = data;
    const size = file.size;
    if ((size / 1024) <= 2048) {
        return true;
    } else {
        return false;
    }
}